import { Injectable } from '@angular/core';
import { GridDataService } from '../../../base-data-services/grid-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import {
  API_METHODS,
  API_URL,
  ASSIGNMENT_GRID_URL,
  OperationType,
} from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import {
  GridModel,
  GridParams,
  GridPostParams,
} from 'common/models/utility-models/list-utility.model';

import { TrainersModel } from 'common/models/page-models/Trainers Model/trainers-data.model';
import {
  ViewTrainersListingModel,
  ViewTrainersGridParams,
} from 'common/models/page-models/View Trainers Model/view-trainers-params.odel';
import { environment } from 'src/environments/environment';
// import { TrainersGridParams, TrainersListingModel, TrainersModel, ViewTrainersGridParams, ViewTrainersListingModel } from 'common/models/page-models/trainers-model';

@Injectable({
  providedIn: 'root',
})
export class ViewTrainersGridDataService extends GridDataService<
  ViewTrainersListingModel,
  TrainersModel
> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.viewTrainers, http, ss);
  }

  createInstance(): ViewTrainersListingModel {
    return new ViewTrainersListingModel();
  }

  override getDeleteUrl(): string {
    return '';
  }

  override getGridParams(param): GridPostParams {
    let params;
    params = new ViewTrainersGridParams();
    params.id = param.id;
    return params;
  }

  override getExtraParam() {
    return 'details';
  }

  override getDataParam() {
    return 'assignmentData';
  }

  override transformDataModel(data: any, param) {
    super.transformDataModel(data, param);

    data[param] = data.details[param];

    data.details[param].forEach((element) => {
      if (
        element.timeslot_info &&
        element.timeslot_info.length > 0 &&
        element.timeslot_info[0].start_date
      ) {
        element.accepted = element.timeslot_info[0].number_of_student;
        element.timeslot_info =
          element.timeslot_info[0].start_date + ' - ' + element.timeslot_info[0].end_date;

        if (element.accepted === 0) {
          element.accepted = 'N/A';
        }
        if (element.non_accepted === 0) {
          element.non_accepted = 'N/A';
        }
        if (element.invited === 0) {
          element.invited = 'N/A';
        }
      } else {
        element.accepted = element.accepted;
        element.non_accepted = element.non_accepted;
        element.invited = element.invited;
      }
    });
    return data;
  }

  // override async createGridModel(
  //   apiRes: any,
  //   queryParam: GridParams,
  //   dataParam: string = 'detail',
  //   extraParam: string = ''
  // ): Promise<any> {
  //   return await new Promise<any>((resolve, reject) => {
  //     const gridModel: any = new GridModel<any>();
  //     if (apiRes.details === null) {
  //       gridModel.extraData = queryParam;
  //       gridModel.originalModel = [];
  //       gridModel.filterModel = [];
  //       gridModel.pageModel = [];
  //       gridModel.pages = [];
  //       resolve(gridModel);
  //     } else {
  //       const modifiedApiRes=apiRes.details
  //       super
  //         .createGridModel(modifiedApiRes, queryParam, 'assignmentData', extraParam)
  //         .then((data) => {
  //           data.extraData = queryParam;
  //           resolve(data);
  //         });
  //     }
  //   }).catch((error) => {
  //     return error;
  //   });
  // }

  // override generateUrl(
  //   type: OperationType,
  //   paramKey = null,
  //   extraKey = null,
  //   data
  // ): string {
  //   if (type === OperationType.VIEW) {
  //     console.log(data);
  //     const trainerId = data?.id || '';
  //     return `${environment.apiUrl}${this.ApiUrl}/${trainerId}`;
  //   }
  //   return super.generateUrl(type, paramKey, extraKey, data);
  // }

  // override async fetchData(queryParams = null, params = null): Promise<any[]> {
  //   console.log(queryParams);
  //   return await new Promise<any>((resolve, reject) => {
  //     const url = this.generateUrl(OperationType.VIEW, null, null, queryParams);
  //     this.apiService
  //       .getData(url)
  //       .then((data) => {
  //         resolve(data);
  //       })
  //       .catch((error) => reject(error));
  //   });
  // }
}
